/**
 * Copyright Motili Inc., 2016 All Rights Reserved
 */

import { PHONE_NUMBER_TYPES } from 'common/utils/constants';
import * as ApiService from 'common/services/ApiService';

export function lookup(number, country) {
    const query = {
        number,
        country: country || 'US',
    };
    return ApiService.get(
        true,
        'TwilioPhoneNumbers/lookup',
        query,
        false,
        undefined,
        undefined,
        true
    );
}
export function lookupWithAccessToken(number, country, accessToken) {
    const query = {
        number,
        country: country || 'US',
    };
    return ApiService.get(
        true,
        'TwilioPhoneNumbers/lookup',
        query,
        false,
        accessToken
    );
}

export function validateMobile(number, country) {
    return lookup(number, country)
        .then(response => {
            if (
                response &&
                response.carrier &&
                isMobileCarrier(response, country)
            ) {
                return { valid: true };
            }
            return { valid: false, message: 'Invalid mobile phone number' };
        })
        .catch(error => {
            console.error(error);
            return {
                valid: false,
                message: getErrorMessage(error, PHONE_NUMBER_TYPES.MOBILE),
                error,
            };
        });
}

export function validatePhone(number, country) {
    return lookup(number, country)
        .then(response => {
            if (response && response.carrier) {
                return { valid: true };
            }
            return { valid: false, message: 'Invalid phone number' };
        })
        .catch(error => {
            console.error(error);
            return {
                valid: false,
                message: getErrorMessage(error, PHONE_NUMBER_TYPES.LANDLINE),
                error,
            };
        });
}

export function validateNumber(number, country) {
    const query = {
        number,
        country: country || 'US',
    };
    return ApiService.get(true, 'TwilioPhoneNumbers/isValid', query)
        .then(response => response)
        .catch(error => {
            console.log(error);
            return false;
        });
}

export async function validateMobileWithAccessToken(
    number,
    accessToken,
    country
) {
    try {
        const response = await lookupWithAccessToken(
            number,
            accessToken,
            country
        );
        return isMobileCarrier(response, country);
    } catch (error) {
        console.error(error);
    }
    return false;
}

export async function validatePhoneWithAccessToken(
    number,
    accessToken,
    country
) {
    try {
        const response = await lookupWithAccessToken(
            number,
            accessToken,
            country
        );
        return response?.carrier;
    } catch (error) {
        console.error(error);
    }
    return false;
}

function getErrorMessage(error, phoneType) {
    switch (error?.statusCode) {
        case 400:
            return 'Bad request for phone number lookup';
        case 404:
            return 'Phone number does not exist and cannot be validated';
        default:
            return phoneType === 'mobile'
                ? 'Error validating mobile phone number. Please try again'
                : 'Error validating phone number. Please try again';
    }
}

function ignoreCarrier(country) {
    switch (country) {
        case 'CA':
            return true;
        default:
            return false;
    }
}

function isMobileCarrier(response, country) {
    if (!response) return false;
    return (
        ignoreCarrier(country) ||
        response?.carrier?.type === 'mobile' ||
        response?.carrier?.type === 'voip'
    );
}
